<script lang="ts">
    import { _ } from "svelte-i18n";
    import { classMap, prefixFilter } from "@smui/common/internal";
    import { ContextFragment } from "@smui/common";
    import { Cell } from "@smui/data-table";
    import { Input } from "@smui/textfield";

    import { createEventDispatcher } from "svelte";

    export let value = "";
    let className = "";
    export { className as class };
    export let editable = true;
    export let numeric = true;
    export let placeholder = "";
    export let colspan = null;
    export let autofocus = true;
    export let maxlength = 200;
    export let withTrailingIcon = false;
    export let id = null;
    export let extraClasses = "";
    export let valueInvalid = false;
    export let ignoreFocus = false;
    //export let dataType = "text";

    let edEl;
    let focused = false;

    let prevValue;

    const dispatch = createEventDispatcher();

    const setFocus = () => {
        if (!focused && edEl && edEl.getElement()) {
            edEl.getElement().focus();
            edEl.getElement().select();
            focused = true;
        }
    };

    $: if (value != prevValue || (value && !prevValue) || (!value && prevValue)) {
        if (prevValue || prevValue == 0) {
            dispatch("change");
        }
        prevValue = value;
    }

    // $: {
    //     console.log({focused});
    //     console.log({edEl});
    //     console.log({value});
    //     console.log("restProps", {...$$restProps});
    // }


//$: if (dataType.toLowerCase() == "number") value = value.replace(/[^0-9.]/g, '');

</script>

<Cell
    numeric
    class="{classMap({
        [className]: true,
        "edit-cell-border": true,
        focused: ignoreFocus? false: focused,
        "text-right": numeric,
        "text-left": !numeric,
    })} {valueInvalid? "tescored-border noborder":""}"
    {colspan}
    style={withTrailingIcon ? "padding-right: 1.2rem !important;" : ""}
    on:click={setFocus}
>
    <Input
        {id}
        type="text"
        class="input-cell pa-0 ma-0 {numeric ? 'text-right' : 'text-left'} {editable ? '' : 'lightgrey grey-text'} {extraClasses} {valueInvalid? "tescored-text":""}"
        data-qa="dt-input-cell"
        {placeholder}
        {maxlength}
        {withTrailingIcon}
        disabled={!editable}
        bind:value
        bind:this={edEl}
        on:focus={(event) => {
            setFocus();
            dispatch("focus", { element: event.currentTarget });
        }}
        on:focusin={(event) => {
            dispatch("focusin", { element: event.currentTarget });
        }}
        on:mouseenter={(event) => {
            dispatch("mouseenter", { element: event.currentTarget });
        }}
        on:blur={(event) => {
            focused = false;
            dispatch("blur", { element: event.currentTarget });
        }}
        on:keydown
        {autofocus}
        {...prefixFilter($$restProps, "input$")}
        on:keyup
        on:input
        on:focusout
    />
    <ContextFragment key="SMUI:textfield:icon:leading" value={false}>
        <slot name="trailingIcon" />
    </ContextFragment>
</Cell>

